export default __webpack_public_path__ + "static/media/multiple_rewards.cc2c2fbe.svg";